var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('transition',{attrs:{"enter-active-class":"animated slideInDown","leave-active-class":"animated fadeOut"}},[_c('div',{staticClass:"report-container",attrs:{"id":"report-container"}},[_c('div',{ref:"report",class:("report " + (_vm.pdf ? 'pdf' : '')),attrs:{"id":"report"}},[_c('div',{class:("report-header " + (_vm.pdf ? 'pdf' : ''))},[_c('img',{ref:"logo",class:("logo " + (_vm.pdf ? 'pdf' : '')),attrs:{"src":_vm.resolveAssetPath(_vm.activeEnvironment.reportLogo || _vm.activeEnvironment.creditsLogo || _vm.activeEnvironment.titleLogo, 'ui/customer')}}),_vm._v(" "),_c('h1',{staticClass:"report-title no-wrap"},[_vm._v(_vm._s(_vm.activeEnvironment.reportTitle || _vm.game.reportTitle || 'Global Leadership Framework Overview'))])]),_vm._v(" "),_c('div',{style:({
          display: 'flex',
          'flex-flow': 'row nowrap',
          'justify-content': 'space-between',
          padding: '4px 50px',
          'font-size': '1.35em',
        })},[_c('div',{staticClass:"no-wrap"},[_vm._v("\n            "+_vm._s(_vm.username)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"no-wrap"},[_vm._v("\n            "+_vm._s(_vm.date)+"\n          ")])]),_vm._v(" "),_c('div',{style:({
          'background-color': 'rgba(134,188,37,1)',
          height: '3px',
        })}),_vm._v(" "),_c('div',{style:({
          padding: '8px 50px',
          'font-size': '1em',
        })},[_vm._v("\n          Thank you for completing the global leadership framework gamulation!\n          Your personal report is based on your demonstrated decisions and preferences.\n          What you've demonstrated expresses what comes most naturally to you at this time,\n          which can give you clues into the types of roles, positions, and experiences that\n          will often feel most aligned and empowering to you.\n          There are no good, no bad, no better or no worse abilities.\n          All humans can, and do, express every capability at different times and you can also develop all your capabilities.\n          Below you can learn more about the capabilities that you most uniquely demonstrate in a work context.\n        ")]),_vm._v(" "),_c('div',{staticClass:"middle-banner",style:({
            display: 'flex',
            'flex-flow': 'row nowrap',
            margin: '5px 0 2px',
            width: '100%',
            height: '145px',
          })},[_c('div',{style:({
              margin: '20px 0 0 125px',
            'font-size': '24px',
            })},[_vm._v("Go as far as your ambition takes you")])]),_vm._v(" "),(!_vm.pdf)?_c('div',{staticClass:"archetype-tabs"},[_c('div',{style:({
              position: 'absolute',
              top: '50%',
              left: '0',
              width: '100%',
              height: '1px',
              'background-color': 'white',
            })}),_vm._v(" "),_vm._l((_vm.sortedTopArchetypeNames),function(name,i){return _c('div',{key:i,staticClass:"archetype-tab",class:{ selected: (_vm.selectedTab === i) },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return (function () { return _vm.onClickTab(i); })($event)}}},[_vm._v("\n            "+_vm._s(name)+"\n          ")])})],2):_vm._e(),_vm._v(" "),_c('div',{class:"archetype-header no-wrap"},[_c('div',{style:({
            margin: '10px 50px 10px 375px',
            padding: '0',
          })},[_vm._v("\n            "+_vm._s((_vm.sortedTopArchetypeNames && _vm.sortedTopArchetypeNames.length > _vm.selectedTab) ? _vm.sortedTopArchetypeNames[_vm.selectedTab] : 'THE CURIOUS')+"\n          ")]),_vm._v(" "),_c('div',{style:({
            position: 'absolute',
            top: '0',
            left: '45px',
            width: '285px',
            height: '285px',
            'z-index': '10',
          })},[_c('img',{staticClass:"selected-icon",attrs:{"src":("/static/reports/deloittearchetypes/" + (_vm.selectedArchetypeIcon || 'Icon_Curious') + ".png")}})]),_vm._v(" "),_c('div',{style:({
            position: 'absolute',
            top: '25px',
            left: '340px',
            width: '20px',
            height: '170px',
            'background-color': 'rgba(134,188,37,.9)',
          })})]),_vm._v(" "),_c('div',{style:({
          margin: '10px 50px 10px 375px',
          'font-size': '27px',
          'line-height': '125%',
          'min-height': '120px',
          padding: '0',
        })},[_vm._v("\n          "+_vm._s(_vm.selectedArchetypeSummary)+"\n        ")]),_vm._v(" "),_c('div',{style:({
          margin: '12px 0 4px',
          padding: '3px 100px',
          'font-size': '19px',
          'background-color': 'rgba(134,188,37,.9)',
          color: 'white',
          position: 'relative',
          'z-index': '1',
          height: '50px',
        })}),_vm._v(" "),_c('div',{style:({
          margin: '12px 0 4px',
          padding: '3px 100px',
          'font-size': '19px',
          'background-color': 'white',
          color: 'black',
          position: 'relative',
          'z-index': '1',
        })},[_vm._v("\n          How might this show up at work?"),_c('br'),_vm._v("Behaviors that typically drive and fuel this archetype are:\n        ")]),_vm._v(" "),_c('div',{style:({
          margin: '6px 0 4px 815px',
          padding: '0 100px',
          'font-size': '10px',
        })},[_vm._v("\n          LEVEL\n        ")]),_vm._v(" "),_vm._l((_vm.selectedArchetypeBehaviors),function(b,i){return _c('div',{key:i,style:({
            display: 'flex',
            'flex-flow': 'column nowrap',
            'align-items': 'flex-start',
            'justify-content': 'center',
            padding: '0 100px',
            margin: '0',
            width: '100%',
            'background-color': 'white',
          })},[_c('div',{style:({
              display: 'flex',
              'flex-flow': 'row nowrap',
              'align-items': 'center',
              'justify-content': 'flex-start',
              padding: '0',
              margin: '0 0 20px',
              height: '45px',
              'background-color': 'white',
            })},[_c('div',{staticClass:"behavior-bullet"},[_c('img',{staticClass:"behavior-bullet-icon",attrs:{"src":("/static/reports/archetypes/" + (_vm.selectedArchetypeIcon || 'Icon_Curious') + ".png")}})]),_vm._v(" "),_c('div',{style:({
              width: '650px',
              margin: '0 45px 0 25px',
              'line-height': '125%',
            })},[_vm._v("\n              "+_vm._s(b.text)+"\n            ")]),_vm._v(" "),_c('star-box',{attrs:{"stars":b.level,"green":""}})],1),_vm._v(" "),(i < _vm.selectedArchetypeBehaviors.length - 1)?_c('div',{style:({
              position: 'relative',
              top: '-10px',
              width: '100%',
              height: '1px',
              'background-color': 'rgba(134,188,37,1)',
            })}):_vm._e()])}),_vm._v(" "),_c('div',{style:({
          'background-color': 'rgba(134,188,37,1)',
          height: '15px',
          margin: '20px 0',
        })}),_vm._v(" "),_c('div',{staticClass:"links-banner",style:({
            display: 'flex',
            'flex-flow': 'row nowrap',
            'align-items': 'flex-end',
            'justify-content': 'flex-start',
            margin: '0',
            padding: '0 75px',
            height: '205px',
          })},_vm._l((_vm.readMoreLinks),function(link,i){return _c('div',{key:i,style:({
              display: 'flex',
              'flex-flow': 'column nowrap',
              'align-items': 'center',
              'justify-content': 'center',
              margin: 'auto 0 0',
              height: '45%',
              width: '16.67%',
              'text-align': 'center',
              'font-size': '85%',
            })},[_c('div',{style:({
                height: '48%',
                'margin-bottom': '2%',
              })},[_vm._v(_vm._s(link.text))]),_vm._v(" "),_c('a',{style:({
                height: '40%',
                width: '90%',
                margin: '0 5%',
                border: '2px solid rgba(134,188,37,1)',
                'border-radius': '5px',
                color: 'white',
                display: 'flex',
                'flex-flow': 'row nowrap',
                'align-items': 'center',
                'justify-content': 'center',
              }),attrs:{"target":"_blank","href":link.link}},[_c('div',{staticClass:"no-wrap",style:({ margin: 'auto 0' })},[_vm._v(_vm._s(link.verb)+" MORE")])])])})),_vm._v(" "),_c('div',{style:({
          padding: '2px 25px',
          width: '100%',
          'border-top': '1px solid white',
          'background-color': 'black',
          color: 'white',
        })},[_vm._v("\n          "+_vm._s(_vm.activeEnvironment.reportFooter)+"\n        ")])],2)])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showDownloading)?_c('div',{staticClass:"download-message"},[_vm._v("Downloading!")]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showNextButton)?_c('button',{staticClass:"btn download-button",on:{"click":function($event){$event.preventDefault();return _vm.onClickDownload($event)}}},[_vm._v("Download")]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showNextButton)?_c('bottom-bar',{ref:"bottomBar",attrs:{"next":_vm.showNarratorNotification ? _vm.onComplete : undefined,"tabindex":3,"noBar":true}},[_c('span',{attrs:{"slot":"button"},slot:"button"},[_c('span',{domProps:{"innerHTML":_vm._s((_vm.narrative && _vm.narrative.nextButtonText) ? _vm.narrative.nextButtonText : ((_vm.game && _vm.game.nextButtonDefaultText) ? _vm.game.nextButtonDefaultText : 'Next'))}})])]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0aca16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/narrative/NarrativeDeloitteReport.vue
// module id = null
// module chunks = 